<template>
    <div>
        <Leftmenu />
        <Header />
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="content-header">
                <Backbutton />
                Корпоративный стандарт {{corpstandart_data.name}}
            </div>
            <div class="content-inner">
                <div class="btn_add" @click="$router.push('/company/corpstandart/'+id+'/type_of_work/new')">Добавить навык</div>
                <div>Сумма баллов нввыков: 
                    <span v-if="total_mark_type_of_works > 100" style="background: red; color: #fff; padding: 7px; border-radius: 3px">{{ total_mark_type_of_works }}</span>
                    <span v-else>{{ total_mark_type_of_works }}</span>
                </div>
                <table>
                    <tr>
                        <th>Наименование навыка</th>
                        <th>Вес</th>
                        <th></th>
                    </tr>
                    <tr v-for="type_of_work in corpstandart_type_of_works_list" :key="type_of_work.id">
                        <td>{{type_of_work.name}}</td>
                        <td>{{type_of_work.value}}</td>
                        <td>
                            <div class="btn_for_table buttons_inline" @click="$router.push('/company/corpstandart/'+id+'/type_of_work/'+type_of_work.id+'/edit')">Редактировать</div>
                            <div class="btn_for_table buttons_inline" @click="$router.push('/company/corpstandart/type_of_work/aspects/'+type_of_work.id)">Перейти</div>
                            <div class="btn_for_table_delete buttons_inline" @click="delete_type_of_work(type_of_work.id)">Удалить</div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import Leftmenu from '@/components/leftmenu.vue'
import Header from '@/components/header.vue'
import Backbutton from '@/components/elements/bacl-button.vue'
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'Corpstandart',
    props: ['id'],
    components: {
        Leftmenu, Header, Backbutton, Success, Error
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            corpstandart_data: {},
            corpstandart_type_of_works_list: {},
            total_mark_type_of_works: 0
        }
    },
    methods: {
        corpstandart() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/corpstandart/show/'+this.id)
            .then(response => {
                this.corpstandart_data = response.data.data
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        corpstandart_type_of_works() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/corpstandart_type_of_works/'+this.id)
            .then(response => {
                this.corpstandart_type_of_works_list = response.data.data
                loader.hide();
                if(this.corpstandart_type_of_works_list.length == 0)
                    this.total_mark_type_of_works = 0
                else {
                    let corp_list = this.corpstandart_type_of_works_list
                    let total = 0;
                    corp_list.forEach(element => {
                        total = total + Number(element.value)
                    })
                    this.total_mark_type_of_works = total
                }
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        delete_type_of_work(type_of_work_id) {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.delete(process.env.VUE_APP_API_URL + '/api/corpstandart_type_of_works/'+type_of_work_id)
            .then(response => {
                this.operation_info = response.data.data
                this.isSuccess = true
                loader.hide();
                this.corpstandart_type_of_works()
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        }
    },
    created() {
        this.corpstandart()
        this.corpstandart_type_of_works()
    }
}
</script>

<style scoped src="../../../assets/style/main.css"></style>
<style scoped src="../../../assets/style/account.css"></style>
<style scoped src="../../../assets/style/buttons.css"></style>